const DEFAULT_CURRENCY_CODE = 'USD'
const DEFAULT_LANGUAGE_CODE = 'en'

export const withIsoCurrencyCode = (
  formatted: string,
  currencyCode?: string | null
) => {
  const normalizedCurrencyCode =
    currencyCode?.toUpperCase() || DEFAULT_CURRENCY_CODE

  if (
    normalizedCurrencyCode === DEFAULT_CURRENCY_CODE ||
    formatted.includes(normalizedCurrencyCode)
  ) {
    return formatted
  }

  return `${formatted} ${normalizedCurrencyCode}`
}

export const formatCurrency = ({
  value,
  currencyCode,
  languageCode,
  minimumFractionDigits,
  compact,
  trailingZeros = true,
}: {
  value: number
  currencyCode?: string | null
  languageCode?: string | null
  minimumFractionDigits?: number
  compact?: boolean
  trailingZeros?: boolean
}) => {
  currencyCode = currencyCode?.toUpperCase() || DEFAULT_CURRENCY_CODE
  languageCode = languageCode || DEFAULT_LANGUAGE_CODE

  const formatter = new Intl.NumberFormat(languageCode, {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits:
      minimumFractionDigits ?? (compact && value > 0 ? 0 : 2),
    ...(compact ? { notation: 'compact' } : {}),
  })

  if (!trailingZeros) {
    const formatted = formatter.format(value)
    // Remove trailing zeros and decimal point if no fractional digits remain
    return withIsoCurrencyCode(formatted.replace(/\.0+$/, ''), currencyCode)
  }
  return withIsoCurrencyCode(formatter.format(value), currencyCode)
}
